'use client';

import { GlobalNavBarRedesign } from './GlobalNavBarRedesign';

interface GeneralNavBarWrapperRedesignProps {
  navData: Record<string, unknown>;
}

export const GeneralNavBarWrapperRedesign = ({
  navData,
}: GeneralNavBarWrapperRedesignProps) => {
  return (
    <div
      className="h-[72px] landscape-short:h-[56px] lg:h-16 w-full max-w-[1280px] mx-auto flex items-center overflow-hidden rounded-[16px]"
      style={{ opacity: 1 }}
    >
      <div className="w-full h-full flex items-center justify-between">
        <GlobalNavBarRedesign data={navData} />
      </div>
    </div>
  );
};
